<template>
  <div class="poc">
    <h1>paiting words poc</h1>
    <h4>enter how many words to paint</h4>
    <input type="number" v-model="wordsToPaintAmount" />
    <span class="word" v-if="word.length > 0">
      <span v-html="wordArr.join('')"></span>
    </span>
  </div>
</template>

<script>
import wordsJson from '@/config/words.json5';
import util from '../util/app-util';

export default {
  name: 'WordsMarkPoc',
  data() {
    return {
      wordArr: [],
      word: '',
      wordsToPaintAmount: 1
    };
  },
  created() {
    const { word } = wordsJson['GREEN_5'].words[0];
    // console.log({ word });
    // console.log(util.stripVowels(word));
    this.word = word;
    this.wordArr = word.split('');
    for (const char of this.word) {
      // console.log(`is ${char}  vowel: ${util.isCharacterVowel(char)}`);
    }
    this.markLetters(1);
  },
  watch: {
    wordsToPaintAmount() {
      this.markLetters();
    }
  },
  methods: {
    markLetters() {
      this.wordArr = this.word.split('');
      let amount = Number(this.wordsToPaintAmount);
      for (const charIndex in this.word) {
        if (util.isCharacterVowel(this.word[charIndex])) {
          amount++;
        }
        if (Number(charIndex) === amount) {
          if (!util.isCharacterVowel(this.word[Number(charIndex) + 1])) {
            amount++;
          }
          this.wordArr.splice(amount, 0, '</span>');
          this.wordArr.unshift('<span class="painted">');
          return;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.poc {
  display: flex;
  flex-direction: column;
  align-items: center;
  input {
    width: 100px;
  }
}

.word {
  font-size: 40px;
}

.painted {
  color: red;
}
</style>
